import { render, staticRenderFns } from "./LootArmorProperties.vue?vue&type=template&id=590af5f6&lang=pug&"
import script from "./LootArmorProperties.vue?vue&type=script&lang=ts&"
export * from "./LootArmorProperties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports